import { type MedplumClient } from '@medplum/core'
import { fetchAllListPages } from 'fhir/graphqlPagination'
import { BaseOrganizationFragment } from 'generated/graphql'
import { GET_ORGANIZATION_LIST } from 'hooks/useOrganizationList.query'

/** Reads every Organization via the shared BaseOrganization list query. */
export async function fetchAllOrganizations(
  medplum: MedplumClient
): Promise<BaseOrganizationFragment[]> {
  return await fetchAllListPages<BaseOrganizationFragment>({
    medplum,
    query: GET_ORGANIZATION_LIST,
    listKey: 'OrganizationList'
  })
}
